import { render, staticRenderFns } from "./stat-list-hero.vue?vue&type=template&id=83987f0a"
import script from "./stat-list-hero.vue?vue&type=script&lang=js"
export * from "./stat-list-hero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports